import { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { BRAND } from "@/data/content";

const NAV_LINKS = [
    { label: "Anasayfa", href: "#anasayfa", testid: "nav-link-anasayfa" },
    { label: "Hizmetler", href: "#hizmetler", testid: "nav-link-hizmetler" },
    { label: "Hakkımızda", href: "#hakkimizda", testid: "nav-link-hakkimizda" },
    { label: "İletişim", href: "#iletisim", testid: "nav-link-iletisim" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 w-full z-40 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-white/85 border-b border-[#0055FF]/10 py-3"
                    : "bg-transparent py-5"
            }`}
        >
            <div className="onx-container flex items-center justify-between">
                {/* Logo */}
                <a
                    href="#anasayfa"
                    data-testid="logo-link"
                    className="flex items-center gap-2.5 group"
                >
                    <div className="relative w-10 h-10 rounded-2xl bg-[#0055FF] flex items-center justify-center overflow-hidden">
                        <Sparkles
                            className="w-5 h-5 text-white"
                            strokeWidth={2.5}
                        />
                        <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent" />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-black text-lg tracking-tight text-[#0B1B2B]">
                            {BRAND.name}
                        </span>
                        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#4A6177]">
                            Temizlik
                        </span>
                    </div>
                </a>

                {/* Desktop Nav */}
                <nav className="hidden md:flex items-center gap-1">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            className="px-4 py-2 text-sm font-semibold text-[#0B1B2B] hover:text-[#0055FF] transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                {/* CTA */}
                <a
                    href={BRAND.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="header-cta-whatsapp"
                    className="hidden md:inline-flex onx-btn-primary !py-2.5 !px-5 text-xs"
                >
                    Hemen Teklif Al
                </a>

                {/* Mobile menu trigger */}
                <button
                    type="button"
                    onClick={() => setOpen((s) => !s)}
                    aria-label="Menüyü aç"
                    data-testid="mobile-menu-toggle"
                    className="md:hidden w-10 h-10 rounded-full border border-[#0B1B2B]/15 flex items-center justify-center text-[#0B1B2B]"
                >
                    {open ? (
                        <X className="w-5 h-5" />
                    ) : (
                        <Menu className="w-5 h-5" />
                    )}
                </button>
            </div>

            {/* Mobile drawer */}
            {open && (
                <div
                    data-testid="mobile-menu-panel"
                    className="md:hidden onx-container mt-3 pb-5"
                >
                    <div className="rounded-3xl bg-white border border-[#0055FF]/15 p-4 shadow-2xl shadow-[#0055FF]/10">
                        <nav className="flex flex-col">
                            {NAV_LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`mobile-${l.testid}`}
                                    className="px-3 py-3 text-base font-semibold text-[#0B1B2B] hover:text-[#0055FF] transition-colors border-b border-[#0055FF]/5 last:border-b-0"
                                >
                                    {l.label}
                                </a>
                            ))}
                        </nav>
                        <a
                            href={BRAND.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-cta-whatsapp"
                            className="onx-btn-primary w-full mt-3"
                        >
                            Hemen Teklif Al
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
